import {i18n} from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.planificadorTareaCustom.fields.id'),
  },
  {
    name: 'nombre',
    label: i18n('entities.planificadorTareaCustom.fields.nombre'),
  },
  {
    name: 'dirigidoA',
    label: i18n('entities.planificadorTareaCustom.fields.dirigidoA'),
  },
  {
    name: 'empleados',
    label: i18n('entities.planificadorTareaCustom.fields.empleados'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'puestos',
    label: i18n('entities.planificadorTareaCustom.fields.puestos'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'sucursales',
    label: i18n('entities.planificadorTareaCustom.fields.sucursales'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'tareas',
    label: i18n('entities.planificadorTareaCustom.fields.tareas'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'activarTiempoLimite',
    label: i18n('entities.planificadorTareaCustom.fields.activarTiempoLimite'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'tipoTiempoLimite',
    label: i18n('entities.planificadorTareaCustom.fields.tipoTiempoLimite'),
  },
  {
    name: 'tiempoLimite',
    label: i18n('entities.planificadorTareaCustom.fields.tiempoLimite'),
  },
  {
    name: 'programada',
    label: i18n('entities.planificadorTareaCustom.fields.programada'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'programar',
    label: i18n('entities.planificadorTareaCustom.fields.programar'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'inicioProgramacion',
    label: i18n('entities.planificadorTareaCustom.fields.inicioProgramacion'),
  },
  {
    name: 'finProgramacion',
    label: i18n('entities.planificadorTareaCustom.fields.finProgramacion'),
  },
  {
    name: 'tipoPeriodicidad',
    label: i18n('entities.planificadorTareaCustom.fields.tipoPeriodicidad'),
  },
  {
    name: 'periodicidad',
    label: i18n('entities.planificadorTareaCustom.fields.periodicidad'),
  },
  {
    name: 'evaluadores',
    label: i18n('entities.planificadorTareaCustom.fields.evaluadores'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.planificadorTareaCustom.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.planificadorTareaCustom.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
